import { render, staticRenderFns } from "./UserAdditionalDetails.vue?vue&type=template&id=15b19175&"
import script from "./UserAdditionalDetails.vue?vue&type=script&lang=js&"
export * from "./UserAdditionalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports